<div class="container-fluid">
    <div class="header-container">
        <div class="page-header"><span class="fa fa-file-text-o"></span>Information for
            claim {{claimObject.ClaimNumber}}:
        </div>
    </div>

    <div class="" style="padding-bottom: 30px;">

        <div class="row">
            <div class="col-md-12 col-sm-12 ">
                <div class="x_panel">
                    <div class="x_title">
                        <h2>{{claimObject.Status}} <small> |  {{claimObject.Insurer}}</small></h2>
                        <ul class="nav navbar-right panel_toolbox">
                            <li style=" padding-right: 10px; ">
                                <button pButton type="button" class="p-button-raised full-width" label="Delete Claim"
                                        (click)="showConfirmation = true;" style="color: #0079c1;"></button>
                            </li>
                            <li class="dropdown">
                                <button pButton type="button" class="p-button-raised full-width" label="Save and Close"
                                        (click)="minimizeAndSaveClaim()" style="color: #0079c1;"></button>
                            </li>
                        </ul>
                        <div class="clearfix"></div>
                    </div>
                    <div class="x_title" *ngIf="showConfirmation">
                        <h2>Confirm deleting of claim</h2>
                        <ul class="nav navbar-right panel_toolbox">
                            <li style=" padding-right: 10px; ">
                                <button pButton type="button" class="p-button-raised full-width" label="Confirm"
                                        (click)="minimizeAndDeleteClaim()"
                                        style="color: #0079c1; border: none !important;"></button>
                            </li>
                            <li class="dropdown">
                                <button pButton type="button" class="p-button-raised full-width" label="Cancel"
                                        (click)="showConfirmation = false;"
                                        style="color: #0079c1; border: none !important;"></button>
                            </li>
                        </ul>
                        <div class="clearfix"></div>
                    </div>
                    <div class="x_content">
                        <div class="col-md-2 col-sm-2  profile_left">

                            <h3 style="color: #0079c1;">{{claimObject.InsuredName}}</h3>
                            <ul class="list-unstyled user_data">
                                <li>
                                    <i class="fa fa-envelope user-profile-icon"></i> {{claimObject.InsuredeMail}}
                                </li>
                                <li>
                                    <i class="fa fa-phone user-profile-icon"></i> {{claimObject.InsuredPhone}}
                                </li>
                            </ul>

                            <div class="ln_solid"></div>
                            <ul class="list-unstyled user_data">
                                <li>
                                    <p style="padding-top: 10px; font-style: italic; font-variant: all-small-caps;">
                                        Claim Number</p>
                                    <input id="" type="text" size="30" pInputText [(ngModel)]="claimObject.ClaimNumber">
                                </li>
                                <li>
                                    <p style="padding-top: 10px; font-style: italic; font-variant: all-small-caps;">
                                        Status</p>
                                    <p-blockUI [blocked]="blockStatus" [target]="sts">
                                        <p (click)="openGoBackInStatus()"
                                           style="font-size: 15px; position: absolute; top: 20%; left:5%; cursor: pointer;">
                                            <i
                                                    class="fa fa-lock fa-1x"></i> Click to go back in status.</p>
                                    </p-blockUI>
                                    <p-panel #sts>
                                        <div class="p-inputgroup">
                                            <p-dropdown [options]="statuses" [(ngModel)]="selectedStatus"
                                                        (onChange)="setStatus()">
                                                <ng-template let-item pTemplate="selectedItem">
                                                    <img src="{{item.value.backgroundImage}}"
                                                         style="width:16px;vertical-align:middle"/>
                                                    <span style="vertical-align:middle; margin-left: .5em">{{item.label}}</span>
                                                </ng-template>
                                                <ng-template let-item pTemplate="item">
                                                    <div class="p-helper-clearfix"
                                                         style="position: relative;height: 25px;">
                                                        <img src="{{item.value.backgroundImage}}"
                                                             style="width:24px;position:absolute;top:1px;left:5px"/>
                                                        <div style="font-size:14px;float:right;margin-top:4px">{{item.label}}</div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                    </p-panel>
                                </li>
                                <li>
                                    <p style="padding-top: 10px; font-style: italic; font-variant: all-small-caps;">
                                        Assessor</p>
                                    <div class="p-inputgroup">
                                        <p-dropdown [options]="employees" [(ngModel)]="selectedEmployee"
                                                    placeholder="{{claimObject.AssigneeName}}" [showClear]="false"
                                                    (onChange)="setEmployee()"></p-dropdown>
                                    </div>
                                </li>
                                <li>
                                    <p style="padding-top: 10px; font-style: italic; font-variant: all-small-caps;">Link
                                        to document</p>
                                    <input id="" type="text" size="30" pInputText
                                           [(ngModel)]="claimObject.DocumentLink">
                                    <div *ngIf="claimObject.DocumentLink != undefined">
                                        <p *ngIf="claimObject.DocumentLink.length > 0" style="cursor: pointer;"
                                           (click)="goToUrl()"><i
                                                class="fa fa-share fa-1x"></i> Go to URL</p>
                                    </div>
                                </li>
                            </ul>
                            <div class="ln_solid"></div>
                        </div>
                        <div class="col-md-10 col-sm-10 ">

                            <div class="" role="tabpanel" data-example-id="togglable-tabs">

                                <p-tabMenu [model]="tabMenuItems" [activeItem]="selectedTabMenuItem">
                                    <ng-template pTemplate="item" let-item let-i="index" style="padding:0px;">
                                        <div class="menu-container-filter" (click)="showPage(item.ID)">
                                            <div class="menu-card-container-filter">
                                                <div class="menu-card-filter">
                                                    <div class="menu-footer-filter">
                                                        <div>{{item.title}}</div>
                                                        <div class="footer-description-filter">{{item.description}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-tabMenu>
                                <div id="myTabContent" class="tab-content">

                                    <!--TASKS-->
                                    <div class="content" *ngIf="showTasks">
                                        <div>

                                            <div class="row" style="padding-top: 20px;">
                                                <div class="col-md-12">
                                                    <div id="todo" class="panel">
                                                        <h5 class="panel-title">Compulsory Tasks:</h5>
                                                        <p style="padding-left: 10px;padding-bottom: 10px;color: red;"
                                                           *ngIf="errorNotUnassignedT">
                                                            You can only mark tasks that have been assigned as
                                                            complete.</p>
                                                        <p style="padding-left: 10px;padding-bottom: 10px;color: red;"
                                                           *ngIf="errorNotYoursT">You
                                                            can only mark tasks assigned to you as complete.</p>
                                                        <div class="panel-content">
                                                            <fieldset>
                                                                <div class="row">
                                                                    <div class="col-md-8"><label
                                                                            style="padding-left:10px">Task
                                                                        description</label></div>
                                                                    <div class="col-md-2"><label
                                                                            style="padding-left:10px">Assignee</label>
                                                                    </div>
                                                                    <div class="col-md-2"><label
                                                                            style="padding-left:10px">Due Date</label>
                                                                    </div>
                                                                </div>
                                                                <ul class="tasks"
                                                                    style="list-style: none;margin-left: -35px;">
                                                                    <div *ngFor="let task of allNotes; let i = index">
                                                                        <div *ngIf="task.Completed === false && task.IsStandardTask === true">
                                                                            <li class="task">
                                                                                <div class="row">
                                                                                    <div class="col-md-8">
                                                                                        <p-checkbox name="groupname"
                                                                                                    value=""
                                                                                                    (onChange)="completeTask(i)"></p-checkbox>
                                                                                        <label for="task{{i}}">{{task.Description}}
                                                                                            <span
                                                                                                    class="line-through radio-label"></span></label>
                                                                                    </div>
                                                                                    <div class="col-md-2">
                                                                                        <p-dropdown
                                                                                                [options]="employees"
                                                                                                [(ngModel)]="task.Assignee"
                                                                                                placeholder="{{task.Assignee}}"
                                                                                                [showClear]="false"
                                                                                                (onChange)="setTaskEmployee(i, $event)"></p-dropdown>
                                                                                    </div>
                                                                                    <div class="col-md-2">
                                                                                        <p-calendar
                                                                                                dateFormat="yy-mm-dd"
                                                                                                [readonlyInput]="true"
                                                                                                [showOnFocus]="true"
                                                                                                [(ngModel)]="task.DueDate"
                                                                                                (onSelect)="setTaskDueDate(i, task.DueDate)"></p-calendar>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </div>
                                                                    </div>
                                                                </ul>
                                                            </fieldset>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr/>

                                            <div class="row" style="padding-top: 20px;">
                                                <div class="col-md-12">
                                                    <div id="todo" class="panel">
                                                        <h5 class="panel-title">Additional Tasks:</h5>
                                                        <p style="padding-left: 10px;padding-bottom: 10px;color: red;"
                                                           *ngIf="errorNotUnassigned">
                                                            You can only mark tasks that have been assigned as
                                                            complete.</p>
                                                        <p style="padding-left: 10px;padding-bottom: 10px;color: red;"
                                                           *ngIf="errorNotYours">You can
                                                            only mark tasks assigned to you as complete.</p>
                                                        <div class="panel-content">
                                                            <fieldset>
                                                                <div class="row"
                                                                     style="margin-left: -5px;padding-bottom:10px;">
                                                                    <div class="col-md-8">
                                                                        <div class="row margin-top-8">
                                                                            <div class="col-md-8">
                                                                                <div class="p-inputgroup">
                                          <span class="p-float-label full-width">
<!--                                            todo(dcorbett) autosize was wrong here-->
                                            <textarea [rows]="1" [cols]="30" pInputTextarea [autoResize]="true"
                                                      [(ngModel)]="note" (keyup.enter)="createTask()"></textarea>
                                              <!--<input id="float-input" type="text" size="30" pInputText [(ngModel)]="note" (keyup.enter)="createTask()">-->
                                            <label for="float-input">Start typing to create a new task and press enter to save it</label>
                                          </span>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-2">
                                                                                <p-button label="or Save as Note"
                                                                                          icon="pi pi-file"
                                                                                          (onClick)="createNote()"
                                                                                          styleClass="p-button-secondary"></p-button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-8"><label
                                                                            style="padding-left:10px">Task
                                                                        description</label></div>
                                                                    <div class="col-md-2"><label
                                                                            style="padding-left:10px">Assignee</label>
                                                                    </div>
                                                                    <div class="col-md-2"><label
                                                                            style="padding-left:10px">Due Date</label>
                                                                    </div>
                                                                </div>
                                                                <ul class="tasks"
                                                                    style="list-style: none;margin-left: -35px;">
                                                                    <div *ngFor="let task of allNotes; let i = index">
                                                                        <div *ngIf="task.Completed === false && task.IsStandardTask !== true">
                                                                            <li class="task">
                                                                                <div class="row">
                                                                                    <div class="col-md-8">
                                                                                        <p-checkbox name="groupname"
                                                                                                    value=""
                                                                                                    (onChange)="completeTask(i)"></p-checkbox>
                                                                                        <label>{{task.Description}}<span
                                                                                                class="line-through radio-label"></span></label>
                                                                                    </div>
                                                                                    <div class="col-md-2">
                                                                                        <p-dropdown
                                                                                                [options]="employees"
                                                                                                [(ngModel)]="task.Assignee"
                                                                                                placeholder="{{task.Assignee}}"
                                                                                                [showClear]="false"
                                                                                                (onChange)="setTaskEmployee(i, $event)"></p-dropdown>
                                                                                    </div>
                                                                                    <div class="col-md-2">
                                                                                        <p-calendar
                                                                                                dateFormat="yy-mm-dd"
                                                                                                [showOnFocus]="true"
                                                                                                [(ngModel)]="task.DueDate"
                                                                                                (onSelect)="setTaskDueDate(i, task.DueDate)"></p-calendar>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </div>
                                                                    </div>

                                                                </ul>
                                                            </fieldset>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row" style="padding-top: 20px;">
                                                <div class="col-md-12">
                                                    <div id="todo" class="panel">
                                                        <h5 class="panel-title">Notes</h5>
                                                        <div class="panel-content">
                                                            <form>
                                                                <fieldset>
                                                                    <div class="row">
                                                                        <div class="col-md-2"><label
                                                                                style="padding-left:10px">Date
                                                                            added</label></div>
                                                                        <div class="col-md-2"><label
                                                                                style="padding-left:10px">Added
                                                                            by</label></div>
                                                                        <div class="col-md-2"><label
                                                                                style="padding-left:10px">Added
                                                                            at</label></div>
                                                                        <div class="col-md-6"><label
                                                                                style="padding-left:10px">Note</label>
                                                                        </div>
                                                                    </div>
                                                                    <ul class="tasks"
                                                                        style="list-style: none;margin-left: -35px;">
                                                                        <div *ngFor="let task of allNotes; let i = index">
                                                                            <div *ngIf="task.Completed === true">
                                                                                <li class="task">
                                                                                    <div class="row">
                                                                                        <div
                                                                                                class="col-md-2 label">{{task.UpdatedDate | date:'medium':'SAST'}}</div>
                                                                                        <div class="col-md-2 label">{{task.Assignee}}</div>
                                                                                        <div class="col-md-2 label">{{task.AddedAt}}</div>
                                                                                        <div class="col-md-6 label">{{task.Description}}</div>
                                                                                    </div>
                                                                                </li>
                                                                            </div>
                                                                        </div>

                                                                    </ul>
                                                                </fieldset>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <!--CLAIMS-->
                                    <div class="content" *ngIf="showClaims">
                                        <div>
                                            <div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="row margin-top-8">
                                                            <h5 style="margin-left: 15px;">Insurer Details:</h5>
                                                        </div>
                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Insurer:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <input type="text" pInputText placeholder="Insurer"
                                                                           name="insurer"
                                                                           [(ngModel)]="claimObject.Insurer"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Agent:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <input type="text" pInputText
                                                                           placeholder="Agent's name" name="agentName"
                                                                           [(ngModel)]="claimObject.AgentName"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">eMail:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <input type="email" pInputText
                                                                           placeholder="Agent's eMail" name="agenteMail"
                                                                           [(ngModel)]="claimObject.AgenteMail"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Phone:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <input type="text" pInputText
                                                                           placeholder="Agent's phone number"
                                                                           name="agentPhone"
                                                                           [(ngModel)]="claimObject.AgentPhone"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="row margin-top-8">
                                                            <h5 style="margin-left: 15px;">Insured Details:</h5>
                                                        </div>
                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Name:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <input type="text" pInputText
                                                                           placeholder="Insured's name"
                                                                           name="insuredName"
                                                                           [(ngModel)]="claimObject.InsuredName"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">eMail:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <input type="email" pInputText
                                                                           placeholder="Insured's eMail"
                                                                           name="insuredeMail"
                                                                           [(ngModel)]="claimObject.InsuredeMail"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Phone:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <input type="text" pInputText
                                                                           placeholder="Insured's phone number"
                                                                           name="insuredPhone"
                                                                           [(ngModel)]="claimObject.InsuredPhone"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <div class="row">


                                                    <div class="col-md-6">

                                                        <div class="row margin-top-8">
                                                            <h5 style="margin-left: 15px;">Item Details:</h5>
                                                        </div>

                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Bikes:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <p-chips [(ngModel)]="bikes" class="full-width"
                                                                             placeholder="Enter bike name and press enter. Multiple bikes can be added."
                                                                             (onAdd)="addBike($event)"
                                                                             (onRemove)="removeBike($event)"></p-chips>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Components:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <div class="p-g" style="margin-bottom:10px">
                                                                        <div class="row">
                                                                            <div class="col-md-12">
                                                                                <div class="col-md-12"
                                                                                     *ngFor="let col of bikeSelectList"
                                                                                     style="padding:5px;">
                                                                                    <div>
                                                                                        <p-radioButton name="bikesGroup"
                                                                                                       value="{{col.label}}"
                                                                                                       label="{{col.label}}"
                                                                                                       [(ngModel)]="bikeSelected"
                                                                                                       inputId="opt1"
                                                                                                       (onClick)="showComponents()"></p-radioButton>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label"></div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <p-chips [(ngModel)]="components" class="full-width"
                                                                             placeholder="Enter components for the above selected bike."
                                                                             (onAdd)="addComponentToBike($event)"
                                                                             (onRemove)="removeComponentToBike($event)"></p-chips>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Sum insured:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <input type="number" (blur)="addSumInsuredToBike()"
                                                                           pInputText
                                                                           placeholder="Sum insured" name="sumInsured"
                                                                           [(ngModel)]="sumInsured"/>
                                                                    <!--<p-inputNumber [(ngModel)]="sumInsured" mode="decimal" locale="en-US" [minFractionDigits]="2"></p-inputNumber>-->
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Excess:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <input type="number" (blur)="addExcessToBike()"
                                                                           pInputText placeholder="Excess"
                                                                           name="excess" [(ngModel)]="excess"/>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="row margin-top-8">
                                                            <h5 style="margin-left: 15px;">Incident Details:</h5>
                                                        </div>
                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Type of Incident:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <p-dropdown [options]="incidentTypes"
                                                                                [(ngModel)]="selectedIncidentType"></p-dropdown>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Incident Location:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <input type="text" pInputText
                                                                           [(ngModel)]="claimObject.IncidentLocation"
                                                                           placeholder="Address where incident occured"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Incident Date:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                                                    <p-calendar [(ngModel)]="claimObject.IncidentDate"
                                                                                placeholder="Incident date"
                                                                                dateFormat="yy-mm-dd"></p-calendar>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row margin-top-8">
                                                            <div class="col-md-4 label">Incident Description:</div>
                                                            <div class="col-md-8">
                                                                <div class="p-inputgroup">
                                  <textarea pInputTextarea [rows]="5"
                                            placeholder="Description of the incident that led to the claim"
                                            name="incidentDetails" [(ngModel)]="claimObject.IncidentDetails"></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!--ATTACHMENTS-->
                                    <div class="content" *ngIf="showAttachments">
                                        <div class="row" style="padding-top:30px">
                                            <div class="col-md-4">
                                                <div class="row margin-top-8">
                                                    <h5 style="margin-left: 15px;">Add attachments:</h5>
                                                </div>
                                                <!--                        todo (dcorbett) multiple was wrong-->
                                                <p-fileUpload [customUpload]="true" name="demo[]"
                                                              (onUpload)="onDoUpload($event)"
                                                              (uploadHandler)="onUpload($event, form)"
                                                              (onRemove)="onRemove($event)"
                                                              [multiple]="true" [maxFileSize]="1000000000"
                                                              [auto]="false"
                                                              [showUploadButton]="true" [showCancelButton]="true" #form>
                                                    <ng-template pTemplate="content">
                                                    </ng-template>
                                                </p-fileUpload>

                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <p-carousel headerText="Attachments" [value]="images">
                                                    <ng-template let-doc pTemplate="item">
                                                        <div class="p-grid p-grid-responsive"
                                                             style="min-width:500px;">
                                                            <div class="p-grid-row">
                                                                <div class="p-grid-col-12"><img src="{{doc.FileURL}}"
                                                                                                height="300"></div>
                                                            </div>
                                                            <div class="p-grid-row" style="padding-top:20px">
                                                                <div class="p-grid-col-6"><strong>Date</strong></div>
                                                                <div class="p-grid-col-6">{{doc.CaptureDate}}</div>
                                                            </div>
                                                            <div class="p-grid-row">
                                                                <div class="p-grid-col-6"><strong>Device</strong></div>
                                                                <div class="p-grid-col-6">{{doc.Device}}</div>
                                                            </div>
                                                            <hr/>
                                                            <div class="p-grid-row">
                                                                <div class="p-grid-col-6"><strong>Back links</strong>
                                                                </div>
                                                                <div class="p-grid-col-6">{{doc.total_backlinks}}</div>
                                                            </div>
                                                            <div class="p-grid-row">
                                                                <div class="p-grid-col-6"><strong>Stock Photos</strong>
                                                                </div>
                                                                <div class="p-grid-col-6">{{doc.total_stock}}</div>
                                                            </div>
                                                            <div class="p-grid-row">
                                                                <div class="p-grid-col-6"><strong>Total
                                                                    Results</strong></div>
                                                                <div class="p-grid-col-6">{{doc.total_results}}</div>
                                                            </div>
                                                            <hr/>
                                                            <div class="p-grid-row">
                                                                <div class="p-grid-col-6"><strong>Viewable
                                                                    Link</strong></div>
                                                                <div class="p-grid-col-6"><a
                                                                        style="text-decoration: underline;text-underline-position: under;"
                                                                        href="{{doc.FileURL}}" target="_blank">View
                                                                    Attachment</a></div>
                                                            </div>
                                                            <div class="p-grid-row">
                                                                <div class="p-grid-col-6"><strong>Location</strong>
                                                                </div>
                                                                <div class="p-grid-col-6">
                                                                    <div class="p-grid-row">
                                                                        <div class="p-grid-col-12">
                                                                            Latitude: {{doc.Lat}}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="p-grid-row">
                                                                <div class="p-grid-col-6"></div>
                                                                <div class="p-grid-col-6">
                                                                    <div class="p-grid-row">
                                                                        <div class="p-grid-col-12">
                                                                            Longitude: {{doc.Long}}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="p-grid-row">
                                                                <div class="p-grid-col-6"></div>
                                                                <div class="p-grid-col-6">
                                                                    <div class="p-grid-row">
                                                                        <div class="p-grid-col-12"><a
                                                                                style="text-decoration: underline;text-underline-position: under;"
                                                                                href="https://www.google.com/maps/search/?api=1&query={{doc.Lat}},{{doc.Long}}"
                                                                                target="_blank">View in Google</a></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <hr/>
                                                        </div>
                                                    </ng-template>
                                                </p-carousel>
                                            </div>
                                        </div>
                                        <div class="row" style="padding-top:30px">
                                            <div class="col-md-4">
                                                <div class="row margin-top-8">
                                                    <h5 style="margin-left: 15px;">Documents:</h5>
                                                </div>
                                                <div class="row margin-top-8" style="margin-left: 15px;">
                                                    <div>
                                                        <ul style="list-style:none;">
                                                            <li *ngFor="let doc of documents"><a href="{{doc.source}}"
                                                                                                 target="_blank">{{doc.title}}</a>
                                                            </li>
                                                        </ul>

                                                    </div>
                                                    <br/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!--QUOTES-->
                                    <div class="content" *ngIf="showQuotes">
                                        <div class="row" style="padding-bottom:15px">
                                            <div class="col-md-12" style="padding:5px;">
                                                <div><h5 style="margin-left: 15px;">Bikes linked to quote:</h5></div>
                                                <div><p style="margin-left: 15px; color: lightgray; font-size: small;">
                                                    Select a bike below to
                                                    see the linked quote</p></div>
                                            </div>
                                            <div class="row col-md-12" style="margin-left: 0px">
                                                <div class="col-md-3" *ngFor="let col of claimObject.Bikes"
                                                     style="padding:5px;">
                                                    <div>
                                                        <p-radioButton name="bikesGroup" value="{{col.Name}}"
                                                                       label="{{col.Name}}"
                                                                       [(ngModel)]="bikeSelected"
                                                                       inputId="opt1"></p-radioButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" style="padding-bottom:15px">
                                            <div class="col-md-12" style="padding:5px;">
                                                <div><h5 style="margin-left: 15px;">Partner:</h5></div>
                                                <div><p style="margin-left: 15px; color: lightgray; font-size: small;">
                                                    Select a partner to
                                                    request a quote from</p></div>
                                            </div>
                                            <div class="row col-md-12" style="margin-left: 0px">
                                                <div style="width:300px">
                                                    <p-dropdown [options]="partners" [(ngModel)]="selectedPartner"
                                                                class="width-300"
                                                                (onChange)="onBikeChange()">
                                                        <ng-template let-item pTemplate="selectedItem">
                                                            <span style="vertical-align:middle; margin-left: .5em">{{item.label}}</span>
                                                        </ng-template>
                                                        <ng-template let-item pTemplate="item">
                                                            <div class="p-helper-clearfix"
                                                                 style="position: relative;height: 25px;">
                                                                <div style="font-size:14px;float:right;margin-top:4px">{{item.label}}</div>
                                                            </div>
                                                        </ng-template>
                                                    </p-dropdown>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="row">

                                                    <div class="col-md-6">
                                                        <div class="row margin-top-8">
                                                            <h5 style="margin-left: 15px;">Bike shop messages:</h5>
                                                        </div>
                                                        <div id="notification-container" class="notification-container">
                                                            <div *ngIf="claimObject.Messages == undefined">
                                                                There are no notifications for this claim
                                                            </div>
                                                            <div *ngIf=" !claimObject.Messages == undefined">
                                                                <div *ngIf="claimObject.Messages.length===0">
                                                                    There are no notifications for this claim
                                                                </div>
                                                            </div>
                                                            <div class="notification"
                                                                 *ngFor="let notification of messages">
                                                                <div
                                                                        [ngClass]="{'bike-shop': notification.Direction==='Outgoing', 'cyclist': notification.Direction==='Incoming'}">
                                                                    <div class="cyclist-name"
                                                                         *ngIf="notification.Direction==='Incoming'">{{notification.To}}</div>
                                                                    <div class="cyclist-name"
                                                                         *ngIf="notification.Direction==='outbound-api'">{{notification.Type}}</div>
                                                                    <div>{{notification.Message}}</div>
                                                                    <div class="date">{{notification.CreatedDate | date : 'medium'}}</div>
                                                                    <div class="date"
                                                                         *ngIf="notification.Status==='UNREAD' && notification.Direction==='Incoming'">
                                                                        <i
                                                                                class="fa fa-check-square"></i> Unread
                                                                    </div>
                                                                    <div class="date"
                                                                         *ngIf="notification.Status==='UNREAD' && notification.Direction==='Outgoing'">
                                                                        <i
                                                                                class="fa fa-check-square"></i> Unread
                                                                    </div>
                                                                    <div class="date"
                                                                         *ngIf="notification.Status==='' && notification.Direction==='Incoming'">
                                                                        <i
                                                                                class="fa fa-check-square-o"
                                                                                style="color:greenyellow;"></i> Read
                                                                    </div>
                                                                    <div class="date"
                                                                         *ngIf="notification.Status==='' && notification.Direction==='Outgoing'">
                                                                        <i
                                                                                class="fa fa-check-square-o"
                                                                                style="color:cornflowerblue"></i> Read
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row margin-top-8">
                                                            <div class="col-md-12">
                                                                <div class="p-inputgroup">
                                                                    <!--                                            todo(dcorbett) autosize was wrong here-->
                                                                    <textarea [rows]="1" [cols]="30" pInputTextarea
                                                                              [autoResize]="true"
                                                                              [(ngModel)]="message"
                                                                              placeholder="Add the message to the bikeshop here"
                                                                              (keyup.enter)="sendMessage()"
                                                                              [disabled]="sending"></textarea>
                                                                    <span class="send-icon fa fa-arrow-up"
                                                                          (click)="sendMessage()"
                                                                          [ngClass]="{'sending': sending}"></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="row margin-top-8">
                                                            <h5 style="margin-left: 15px;">Quote:</h5>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="panel panel-default">
                                                                    <div class="panel-heading">
                                                                    </div>
                                                                    <div class="panel-body">
                                                                        <div class="table-responsive">
                                                                            <table class="table table-condensed">
                                                                                <thead>
                                                                                <tr>
                                                                                    <td><strong>Name</strong></td>
                                                                                    <td class="text-center"><strong>Unit
                                                                                        Price</strong></td>
                                                                                    <td class="text-center"><strong>Quantity</strong>
                                                                                    </td>
                                                                                    <td class="text-right"><strong>Total
                                                                                        Price</strong></td>
                                                                                </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                <tr *ngFor="let item of lineItems">
                                                                                    <td>{{item.Description}}</td>
                                                                                    <td class="text-center">
                                                                                        R {{item.UnitPrice | number: ".2-2"}}</td>
                                                                                    <td class="text-center">{{item.Quantity | number: ".2-2"}}</td>
                                                                                    <td class="text-right">
                                                                                        R {{item.UnitPrice_IncludingTax | number: ".2-2"}}</td>
                                                                                </tr>
                                                                                <tr style="line-height: 0em;">
                                                                                    <td class="thick-line"></td>
                                                                                    <td class="thick-line"></td>
                                                                                    <td class="thick-line text-center">
                                                                                        <strong>Subtotal</strong></td>
                                                                                    <td class="thick-line text-right">
                                                                                        R {{subtotal | number: ".2-2"}}</td>
                                                                                </tr>
                                                                                <tr style="line-height: 0em;">
                                                                                    <td class="no-line"></td>
                                                                                    <td class="no-line"></td>
                                                                                    <td class="no-line text-center">
                                                                                        <strong>Tax</strong></td>
                                                                                    <td class="no-line text-right">
                                                                                        R {{tax | number: ".2-2"}}</td>
                                                                                </tr>
                                                                                <tr style="line-height: 0em;">
                                                                                    <td class="no-line"></td>
                                                                                    <td class="no-line"></td>
                                                                                    <td class="no-line text-center">
                                                                                        <strong>Total</strong></td>
                                                                                    <td class="no-line text-right">
                                                                                        R {{total | number: ".2-2"}}</td>
                                                                                </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!--MESSAGING-->
                                    <div class="content" *ngIf="showMessages">
                                        <div class="row">
                                            <div class="col-md-10">
                                                <div id="notification-container" class="notification-container">
                                                    <div *ngIf="claimObject.Messages == undefined">
                                                        There are no notifications for this claim
                                                    </div>
                                                    <div *ngIf="!claimObject.Messages == undefined">
                                                        <div *ngIf="claimObject.Messages.length===0">
                                                            There are no notifications for this claim
                                                        </div>
                                                    </div>
                                                    <div class="notification"
                                                         *ngFor="let notification of claimObject.Messages">
                                                        <div
                                                                [ngClass]="{'bike-shop': notification.Direction==='Outgoing', 'cyclist': notification.Direction==='Incoming'}">
                                                            <!--                              todo (dcorbett): claimObject.AssuredName does not exist -->
                                                            <!--                              <div class="cyclist-name"-->
                                                            <!--                                   *ngIf="notification.Direction==='Incoming'">{{claimObject.AssuredName}}</div>-->
                                                            <div class="cyclist-name"
                                                                 *ngIf="notification.Direction==='outbound-api'">{{notification.Type}}</div>
                                                            <div>{{notification.Message}}</div>
                                                            <div class="date">Sent to {{notification.To}}</div>
                                                            <div class="date">{{notification.CreatedDate | date : 'medium'}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="row margin-top-8">
                                                    <div class="col-md-12 label">Templates:</div>
                                                </div>
                                                <div class="p-inputgroup">
                                                    <button pButton type="button" class="p-button-raised full-width"
                                                            label="Client to complete claim"
                                                            (click)="addTamplateMessage('CompleteClaim')"></button>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="row margin-top-8">
                                            <div class="col-md-10">
                                                <div class="p-inputgroup">
                                                    <!--                                            todo(dcorbett) autosize was wrong here-->
                                                    <textarea type="text" pInputText [(ngModel)]="messageM" [rows]="1"
                                                              [cols]="30" pInputTextarea
                                                              [autoResize]="true"
                                                              placeholder="Add the message to the customer here"
                                                              (keyup)="getSMSCount()"
                                                              (keyup.enter)="sendMessage()"
                                                              [disabled]="sendingM"></textarea>

                                                    <span class="send-icon fa fa-arrow-up" (click)="sendMessages()"
                                                          [ngClass]="{'sending': sending}"></span>
                                                </div>
                                                <p>{{messageM.length}} characters</p>
                                                <p>{{messageMSMS}} messages</p>
                                            </div>
                                            <div class="col-md-1">

                                            </div>
                                        </div>
                                    </div>

                                    <!--PROCUREMNER-->
                                    <div class="content" *ngIf="showProcurement">
                                        <app-procurement></app-procurement>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!--
        <div class="row" style="padding-bottom: 30px;">
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="well well-sm">
              <div class="row">
                <div class="col-sm-6 col-md-1">
                </div>
                <div class="col-sm-6 col-md-4">
                  <h3 style="color: #0079c1; padding-top:6px">
                    {{claimObject.InsuredName}}
                  </h3>
                  <small style="color: gray;font-size: 15px;">
                    <cite title="email"><i class="fa fa-envelope"></i> {{claimObject.InsuredeMail}}</cite>
                  </small>
                  <br />
                  <small style="color: gray;font-size: 15px;">
                    <cite title="phone"><i class="fa fa-phone"></i> {{claimObject.InsuredPhone}}</cite>
                  </small>
                </div>
                <div class="col-sm-6 col-md-7">
                  <div class="row">
                    <div class="col-md-3">
                      <h5 style="color: #0079c1;">
                        {{claimObject.Insurer}}
                      </h5>
                    </div>
                    <div class="col-md-4">
                      <p-blockUI [blocked]="blockStatus" [target]="sts">
                        <p style="font-size: 15px; position: absolute; top: 20%; left:5%; cursor: pointer;"><i class="fa fa-lock fa-1x"></i> Complete compulsory tasks.</p>
                      </p-blockUI>
                      <p-panel #sts>
                        <div class="p-inputgroup">
                          <p-dropdown [options]="statuses" [(ngModel)]="selectedStatus" (onChange)="setStatus()">
                            <ng-template let-item pTemplate="selectedItem">
                              <img src="{{item.value.backgroundImage}}" style="width:16px;vertical-align:middle" />
                              <span style="vertical-align:middle; margin-left: .5em">{{item.label}}</span>
                            </ng-template>
                            <ng-template let-item pTemplate="item">
                              <div class="p-helper-clearfix" style="position: relative;height: 25px;">
                                <img src="{{item.value.backgroundImage}}" style="width:24px;position:absolute;top:1px;left:5px" />
                                <div style="font-size:14px;float:right;margin-top:4px">{{item.label}}</div>
                              </div>
                            </ng-template>
                          </p-dropdown>
                        </div>
                      </p-panel>

                    </div>
                    <div class="col-md-3">
                      <div class="p-inputgroup">
                        <p-dropdown [options]="employees" [(ngModel)]="selectedEmployee" placeholder="{{claimObject.AssigneeName}}" [showClear]="false" (onChange)="setEmployee()"></p-dropdown>
                      </div>
                    </div>
                    <div class="col-md-2">

                      <button pButton type="button" class="p-button-raised full-width" label="Close" (click)="minimizeAndSaveClaim()"></button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <p style="font-size: 15px; position: absolute; top: 20%; left:5%; cursor: pointer;" (click)="goToUrl()"><i class="fa fa-link fa-1x"></i> Link to document</p>
                    </div>
                    <div class="col-md-7">
                      <input id="" type="text" size="30" pInputText [(ngModel)]="claimObject.DocumentLink">
                    </div>
                    <div class="col-md-2">
                      <button pButton type="button" class="p-button-raised full-width" label="Delete Claim" (click)="minimizeAndDeleteClaim()"></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p-tabMenu [model]="tabMenuItems" [activeItem]="selectedTabMenuItem">
          <ng-template pTemplate="item" let-item let-i="index" style="padding:0px;">
            <div class="menu-container-filter" (click)="showPage(item.ID)">
              <div class="menu-card-container-filter">
                <div class="menu-card-filter">
                  <div class="menu-footer-filter">
                    <div>{{item.title}}</div>
                    <div class="footer-description-filter">{{item.description}}</div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </p-tabMenu>


        <div class="content" *ngIf="showTasks">
          <app-tasks [claimObject]="claimObject" [messageService]="messageService"></app-tasks>
        </div>


        <div class="content" *ngIf="showClaims">
          <div>
            <div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row margin-top-8">
                    <h5 style="margin-left: 15px;">Insurer Details:</h5>
                  </div>
                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Insurer:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Insurer" name="insurer" [(ngModel)]="claimObject.Insurer" />
                      </div>
                    </div>
                  </div>
                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Agent:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Agent's name" name="agentName" [(ngModel)]="claimObject.AgentName" />
                      </div>
                    </div>
                  </div>
                  <div class="row margin-top-8">
                    <div class="col-md-4 label">eMail:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <input type="email" pInputText placeholder="Agent's eMail" name="agenteMail" [(ngModel)]="claimObject.AgenteMail" />
                      </div>
                    </div>
                  </div>
                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Phone:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Agent's phone number" name="agentPhone" [(ngModel)]="claimObject.AgentPhone" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row margin-top-8">
                    <h5 style="margin-left: 15px;">Insured Details:</h5>
                  </div>
                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Name:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Insured's name" name="insuredName" [(ngModel)]="claimObject.InsuredName" />
                      </div>
                    </div>
                  </div>
                  <div class="row margin-top-8">
                    <div class="col-md-4 label">eMail:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <input type="email" pInputText placeholder="Insured's eMail" name="insuredeMail" [(ngModel)]="claimObject.InsuredeMail" />
                      </div>
                    </div>
                  </div>
                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Phone:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Insured's phone number" name="insuredPhone" [(ngModel)]="claimObject.InsuredPhone" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div>
              <div class="row">


                <div class="col-md-6">

                  <div class="row margin-top-8">
                    <h5 style="margin-left: 15px;">Item Details:</h5>
                  </div>

                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Bikes:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <p-chips [(ngModel)]="bikes" class="full-width" placeholder="Enter bike name and press enter. Multiple bikes can be added." (onAdd)="addBike($event)" (onRemove)="removeBike($event)"></p-chips>
                      </div>
                    </div>
                  </div>
                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Components:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <div class="p-g" style="margin-bottom:10px">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="col-md-12" *ngFor="let col of bikeSelectList" style="padding:5px;">
                                <div><p-radioButton name="bikesGroup" value="{{col.label}}" label="{{col.label}}" [(ngModel)]="bikeSelected" inputId="opt1" (onClick)="showComponents()"></p-radioButton></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row margin-top-8">
                    <div class="col-md-4 label"></div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <p-chips [(ngModel)]="components" class="full-width" placeholder="Enter components for the above selected bike." (onAdd)="addComponentToBike($event)" (onRemove)="removeComponentToBike($event)"></p-chips>
                      </div>
                    </div>
                  </div>

                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Sum insured:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <input type="text" (blur)="addSumInsuredToBike()" pInputText placeholder="Sum insured" name="sumInsured" [(ngModel)]="sumInsured" />
                      </div>
                    </div>
                  </div>

                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Excess:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <input type="text" (blur)="addExcessToBike()" pInputText placeholder="Excess" name="excess" [(ngModel)]="excess" />
                      </div>
                    </div>
                  </div>

                </div>
                <div class="col-md-6">
                  <div class="row margin-top-8">
                    <h5 style="margin-left: 15px;">Incident Details:</h5>
                  </div>
                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Type of Incident:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <p-dropdown [options]="incidentTypes" [(ngModel)]="selectedIncidentType"></p-dropdown>
                      </div>
                    </div>
                  </div>



                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Incident Location:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <input type="text" pInputText [(ngModel)]="claimObject.IncidentLocation" placeholder="Address where incident occured" />
                      </div>
                    </div>
                  </div>
                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Incident Date:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <p-calendar [(ngModel)]="claimObject.IncidentDate" placeholder="Incident date" dateFormat="yy-mm-dd"></p-calendar>
                      </div>
                    </div>
                  </div>
                  <div class="row margin-top-8">
                    <div class="col-md-4 label">Incident Description:</div>
                    <div class="col-md-8">
                      <div class="p-inputgroup">
                        <textarea pInputTextarea [rows]="5" placeholder="Description of the incident that led to the claim" name="incidentDetails" [(ngModel)]="claimObject.IncidentDetails"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="content" *ngIf="showAttachments">
          <app-insurance-attachments [claimObject]="claimObject" [messageService]="messageService"></app-insurance-attachments>
        </div>


        <div class="content" *ngIf="showQuotes">
          <app-insurance-quote [claimObject]="claimObject" [messageService]="messageService"></app-insurance-quote>
        </div>


        <div class="content" *ngIf="showMessages">
          <app-insurnace-messaging [claimObject]="claimObject" [messageService]="messageService"></app-insurnace-messaging>
        </div>


        <div class="content" *ngIf="showProcurement">
          <app-procurement></app-procurement>
        </div>
        -->
    </div>
</div>
